var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed h-full w-full flex",attrs:{"id":"content"}},[_c('LeftPanel'),_c('Map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }